export default __webpack_public_path__ + "static/media/DNo.20-4.271a50f9.jpg";